import {
  MO_TEMPLATE_ALL,
  MO_TEMPLATE_GET,
  MO_TEMPLATE_PUT,
  MO_TEMPLATE_DELETE,
  MO_TEMPLATE_POST,
  MO_TEMPLATE_LOADING,
  MO_TEMPLATE_ERROR,
} from '../../actions/types';

const initialState = {
  moTemplate: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case MO_TEMPLATE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MO_TEMPLATE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MO_TEMPLATE_POST:
      return { isLoading: false, isCompleted: true };
    case MO_TEMPLATE_PUT:
      return { isLoading: false, isCompleted: true };
    case MO_TEMPLATE_DELETE:
      return { isLoading: false, isCompleted: true };
    case MO_TEMPLATE_LOADING:
      return { isLoading: true, isCompleted: true };
    case MO_TEMPLATE_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
